module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Nouveau projet")]), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "project-edition-project-name"
    }
  }, [_vm._v("nom du projet")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project-edition-project-name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPublic),
      expression: "isPublic"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPublic) ? _vm._i(_vm.isPublic, null) > -1 : (_vm.isPublic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isPublic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPublic = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isPublic = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPublic = $$c
        }
      }
    }
  }), _vm._v("rendre le projet public")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "project-edition-scene-width"
    }
  }, [_vm._v("largeur de la scène (pixels)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sceneWidth),
      expression: "sceneWidth"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project-edition-scene-width",
      "type": "text"
    },
    domProps: {
      "value": (_vm.sceneWidth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sceneWidth = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "project-edition-scene-height"
    }
  }, [_vm._v("hauteur de la scène (pixels)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sceneHeight),
      expression: "sceneHeight"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project-edition-scene-height",
      "type": "text"
    },
    domProps: {
      "value": (_vm.sceneHeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sceneHeight = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "project-edition-description"
    }
  }, [_vm._v("description")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project-edition-description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "project-edition-instructions"
    }
  }, [_vm._v("instructions")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instructions),
      expression: "instructions"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project-edition-instructions",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.instructions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.instructions = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "project-edition-main-program-id"
    }
  }, [_vm._v("programme principal")]), (_vm.resources) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mainProgramId),
      expression: "mainProgramId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project-edition-main-program-id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mainProgramId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.resources), function(resource) {
    return (resource.media_type === 'text/vnd.colombbus.declick.script') ? _c('option', {
      class: {
        selected: _vm.mainProgramId === resource.id
      },
      domProps: {
        "value": resource.id
      }
    }, [_vm._v(_vm._s(resource.file_name))]) : _vm._e()
  }), 0) : _vm._e()]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showProjectDetails
    }
  }, [_vm._v("annuler")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateProject
    }
  }, [_vm._v("enregistrer les modifications")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4256d03e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/create/ProjectEditor.vue
// module id = 591
// module chunks = 2